export default __webpack_public_path__ + "static/media/rebatesBackground-update.6bc7b7ed.jpg";